export enum VariableScope {
  /** @see Design variable. */
  application = 'app',
  conversation = 'conv',
  /** @see DesignModule variable. */
  module = 'mod',
  output = 'out',
  parameter = 'param'
}
